var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"waiver",attrs:{"id":"onerisk-waiver-container"}},[_c('div',{staticClass:"one-risk__window"},[_c('iframe',{attrs:{"id":"one-risk__iframe","src":_vm.oneRiskUrl,"title":"Sign Waiver"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }